// extracted by mini-css-extract-plugin
export var arrow = "ComparisonTable-module--arrow--32680";
export var column = "ComparisonTable-module--column--47742";
export var fadeIn = "ComparisonTable-module--fadeIn--a2358";
export var green = "ComparisonTable-module--green--89288";
export var hasLink = "ComparisonTable-module--has-link--b2388";
export var heading = "ComparisonTable-module--heading--7a680";
export var hidden = "ComparisonTable-module--hidden--15564";
export var red = "ComparisonTable-module--red--79fc5";
export var section = "ComparisonTable-module--section--0de57";
export var subhead = "ComparisonTable-module--subhead--404d8";
export var table = "ComparisonTable-module--table--a1029";
export var visible = "ComparisonTable-module--visible--68c34";